import { theme } from './theme';

/** The official wordmark, in the variant that reads on the current surface.
 *  Files live in public/brand and are served as-is; source:
 *  https://my.trask.cz/images/trask_logo_{blue,white}.png */
export function logoSrc(): string {
  const variant = theme() === 'dark' ? 'trask-white' : 'trask-blue';
  return `${import.meta.env.BASE_URL}brand/${variant}.png`;
}
